import { GET_BANK_ANALYTICS, GET_BANK_ANALYTICS_DETAIL } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getBankAnalytics = (payload) => {  
  return apiInstance.post(GET_BANK_ANALYTICS, payload);
};

export const getBankAnalyticsForTable = (payload) => {  
  return apiInstance.post(GET_BANK_ANALYTICS_DETAIL, payload);
};